import React, { useMemo } from 'react';
import { GeoJSONLayer } from 'react-mapbox-gl';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core';
import { CoordinatesExact } from '../../models/Coordinates';

const Route = ({ index, coordinatesArray, visible, options }) => {
  const theme = useTheme();

  const sourceData = useMemo(
    () => ({
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: coordinatesArray.map(({ longitude, latitude }) => [longitude, latitude]),
      },
      properties: {
        width: options && Number.isFinite(options.width) ? options.width : 5,
        color: (options && options.color) || theme.palette.map.route,
      },
    }),
    [coordinatesArray, options, theme.palette.map.route]
  );

  const layerFeatures = useMemo(
    () => ({
      type: 'FeatureCollection',
      features: visible ? [sourceData] : [],
    }),
    [visible, sourceData]
  );

  return (
    <GeoJSONLayer
      id={`route${index}`}
      type="geojson"
      data={layerFeatures}
      lineLayout={{
        'line-join': 'round',
        'line-cap': 'round',
      }}
      linePaint={{
        'line-color': ['get', 'color'],
        'line-width': ['get', 'width'],
      }}
    />
  );
};

Route.propTypes = {
  coordinatesArray: PropTypes.arrayOf(CoordinatesExact),
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  visible: PropTypes.bool,
  options: PropTypes.shape({ color: PropTypes.string, width: PropTypes.number }),
};

Route.defaultProps = {
  coordinatesArray: [],
  index: 0,
  visible: true,
  options: undefined,
};

export default React.memo(Route);
